import React, { useState } from 'react';
import { Link } from 'react-router-dom';


const plans = [
  {
    id: 'gratis',
    name: 'Gratis',
    nameNote: 'for alltid',
    price: '0',
    period: 'kr / mnd',
    color: '#8A95A3',
    description: 'Kom i gang med grunnleggende veikart og bomkalkulator.',
    features: [
      { text: 'Interaktivt veikart', included: true },
      { text: 'Bomkalkulator (5 søk/dag)', included: true },
      { text: '1 kjøretøy', included: true },
      { text: 'Grunnleggende trafikkvarsler', included: true },
      { text: 'Sanntids trafikkkamera', included: false },
      { text: 'Ubegrenset bomberegning', included: false },
      { text: 'PDF-fakturaer', included: false }
    ],
    cta: 'Start gratis'
  },
  {
    id: 'normal',
    name: 'Normal',
    nameNote: 'mest populær',
    price: '149',
    period: 'kr / mnd',
    color: '#3B6FD4',
    description: 'For daglige pendlere som vil ha full kontroll på veien.',
    features: [
      { text: 'Interaktivt veikart', included: true },
      { text: 'Ubegrenset bomkalkulator', included: true },
      { text: 'Opptil 3 kjøretøy', included: true },
      { text: 'Avanserte trafikkvarsler', included: true },
      { text: 'Sanntids trafikkkamera', included: true },
      { text: 'Ubegrenset bomberegning', included: true },
      { text: 'PDF-fakturaer', included: true }
    ],
    cta: 'Velg Normal',
    popular: true
  },
  {
    id: 'premium',
    name: 'Premium',
    nameNote: 'for profesjonelle',
    price: '299',
    period: 'kr / mnd',
    color: '#E8941A',
    description: 'For profesjonelle sjåfører og bedrifter med flåtebehov.',
    features: [
      { text: 'Interaktivt veikart', included: true },
      { text: 'Ubegrenset bomkalkulator', included: true },
      { text: 'Opptil 5 kjøretøy', included: true },
      { text: 'Avanserte trafikkvarsler', included: true },
      { text: 'Sanntids trafikkkamera', included: true },
      { text: 'Ubegrenset bomberegning', included: true },
      { text: 'PDF-fakturaer', included: true },
      { text: 'Prioritert support', included: true }
    ],
    cta: 'Velg Premium'
  }
];

const PricingSection = () => {
  const [hoveredPlan, setHoveredPlan] = useState(null);

  return (
    <section style={{ background: '#0A0F18', padding: '80px 0 120px', position: 'relative', overflow: 'hidden' }}>
      {/* Background landscape */}
      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '45%', overflow: 'hidden' }}>
        <img
          src="https://img.rocket.new/generatedImages/rocket_gen_img_12bf9c050-1772187879227.png"
          alt="Panoramic Norwegian mountain landscape with snow-capped peaks and deep blue fjord at dusk"
          style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top', opacity: 0.05, filter: 'grayscale(100%)' }}
        />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, #0A0F18 0%, transparent 50%)' }} />
      </div>
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 5%', position: 'relative', zIndex: 1 }}>

        {/* Header */}
        <div style={{ marginBottom: '60px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '20px' }}>
            <div style={{
              fontFamily: 'monospace', fontSize: '0.6rem',
              letterSpacing: '0.3em', color: 'rgba(59,111,212,0.6)',
              textTransform: 'uppercase'
            }}>05 — Priser</div>
            <div style={{ height: '1px', background: 'rgba(59,111,212,0.2)', width: '60px' }} />
          </div>

          <div style={{ display: 'flex', alignItems: 'flex-end', gap: '32px', flexWrap: 'wrap' }}>
            <h2 style={{
              fontFamily: '"Arial Black", Impact, sans-serif',
              fontSize: 'clamp(2rem, 6vw, 5.5rem)',
              fontWeight: 900, color: '#EEF0F2',
              letterSpacing: '-0.04em', lineHeight: 0.9,
              textTransform: 'uppercase', margin: 0
            }}>VELG DITT<br /><span style={{ color: '#3B6FD4' }}>ABONNEMENT</span></h2>
            <p style={{
              fontFamily: 'Georgia, serif', fontStyle: 'italic',
              fontSize: '1rem', color: 'rgba(138,149,163,0.6)',
              maxWidth: '280px', lineHeight: 1.7,
              paddingBottom: '8px', margin: 0
            }}>Ingen bindingstid. Ingen skjulte kostnader. Start gratis og oppgrader når du er klar.</p>
          </div>
        </div>

        {/* Pricing cards — responsive grid */}
        <div className="pricing-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px', alignItems: 'start' }}>
          {plans?.map((plan, i) => (
            <div
              key={plan?.id}
              onMouseEnter={() => setHoveredPlan(plan?.id)}
              onMouseLeave={() => setHoveredPlan(null)}
              className="pricing-card"
              style={{
                marginTop: i === 0 ? '0' : i === 1 ? '28px' : '56px',
                background: plan?.popular ? '#0F1E36' : '#111620',
                border: `1px solid ${hoveredPlan === plan?.id || plan?.popular ? plan?.color + '40' : 'rgba(255,255,255,0.05)'}`,
                position: 'relative', overflow: 'hidden',
                transition: 'all 300ms ease',
                transform: hoveredPlan === plan?.id ? 'translateY(-6px)' : 'none'
              }}
            >
              {/* Top color bar */}
              <div style={{ height: '4px', background: plan?.color, width: '100%' }} />

              <div style={{ padding: '28px 24px' }}>
                {/* Plan name */}
                <div style={{ marginBottom: '20px' }}>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: '10px', flexWrap: 'wrap' }}>
                    <span style={{
                      fontFamily: '"Arial Black", Impact, sans-serif',
                      fontSize: '1.3rem', fontWeight: 900,
                      color: plan?.color, letterSpacing: '-0.02em',
                      textTransform: 'uppercase'
                    }}>NordPass</span>
                    <span style={{
                      fontFamily: 'Georgia, serif', fontStyle: 'italic',
                      fontSize: '1.2rem', color: '#EEF0F2'
                    }}>{plan?.name}</span>
                  </div>
                  <div style={{
                    fontFamily: 'monospace', fontSize: '0.55rem',
                    letterSpacing: '0.2em', color: `${plan?.color}80`,
                    textTransform: 'uppercase', marginTop: '4px'
                  }}>{plan?.nameNote}</div>
                </div>

                {/* Price */}
                <div style={{ marginBottom: '20px', paddingBottom: '20px', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '4px' }}>
                    <span style={{
                      fontFamily: '"Arial Black", Impact, sans-serif',
                      fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
                      fontWeight: 900, color: '#EEF0F2',
                      letterSpacing: '-0.06em', lineHeight: 0.85
                    }}>{plan?.price === '0' ? 'GRATIS' : plan?.price}</span>
                    {plan?.price !== '0' && (
                      <span style={{
                        fontFamily: 'Georgia, serif', fontStyle: 'italic',
                        fontSize: '0.85rem', color: 'rgba(138,149,163,0.6)',
                        paddingTop: '8px'
                      }}>{plan?.period}</span>
                    )}
                  </div>
                </div>

                {/* Description */}
                <p style={{
                  fontFamily: 'Georgia, serif', fontStyle: 'italic',
                  fontSize: '0.875rem', color: 'rgba(138,149,163,0.7)',
                  lineHeight: 1.65, margin: '0 0 20px'
                }}>{plan?.description}</p>

                {/* Features */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '28px' }}>
                  {plan?.features?.map((feat, fi) => (
                    <div key={fi} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div style={{
                        width: '16px', height: '16px', flexShrink: 0,
                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                      }}>
                        {feat?.included ? (
                          <div style={{
                            width: '8px', height: '8px',
                            background: plan?.color, borderRadius: '0'
                          }} />
                        ) : (
                          <div style={{
                            width: '8px', height: '1px',
                            background: 'rgba(255,255,255,0.1)'
                          }} />
                        )}
                      </div>
                      <span style={{
                        fontFamily: 'Georgia, serif',
                        fontStyle: feat?.included ? 'normal' : 'italic',
                        fontSize: '0.8125rem',
                        color: feat?.included ? 'rgba(238,240,242,0.8)' : 'rgba(138,149,163,0.3)',
                        textDecoration: feat?.included ? 'none' : 'line-through',
                        textDecorationColor: 'rgba(138,149,163,0.2)'
                      }}>{feat?.text}</span>
                    </div>
                  ))}
                </div>

                {/* CTA */}
                <Link
                  to="/login"
                  style={{
                    display: 'block', textAlign: 'center',
                    padding: '14px 24px',
                    background: plan?.popular ? plan?.color : 'transparent',
                    border: `1px solid ${plan?.color}`,
                    color: plan?.popular ? '#EEF0F2' : plan?.color,
                    fontFamily: '"Arial Black", sans-serif',
                    fontSize: '0.7rem', fontWeight: 900,
                    letterSpacing: '0.12em', textTransform: 'uppercase',
                    textDecoration: 'none',
                    transition: 'all 200ms cubic-bezier(0.34, 1.56, 0.64, 1)'
                  }}
                  className="btn-spring btn-aurora"
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = plan?.color;
                    e.currentTarget.style.color = '#EEF0F2';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = plan?.popular ? plan?.color : 'transparent';
                    e.currentTarget.style.color = plan?.popular ? '#EEF0F2' : plan?.color;
                  }}
                >{plan?.cta}</Link>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <div style={{
          marginTop: '60px',
          display: 'flex', alignItems: 'center', gap: '24px',
          paddingTop: '40px', borderTop: '1px solid rgba(255,255,255,0.04)',
          flexWrap: 'wrap'
        }}>
          <div style={{
            fontFamily: 'Georgia, serif', fontStyle: 'italic',
            fontSize: '0.8rem', color: 'rgba(138,149,163,0.4)',
            lineHeight: 1.6
          }}>* Alle priser inkl. mva. Abonnement kan sies opp når som helst.</div>
        </div>
      </div>

      <style>{`
        @media (max-width: 767px) {
          .pricing-grid { grid-template-columns: 1fr !important; }
          .pricing-card { margin-top: 0 !important; }
        }
        @media (min-width: 768px) and (max-width: 1023px) {
          .pricing-grid { grid-template-columns: 1fr 1fr !important; }
          .pricing-card:last-child { grid-column: span 2; max-width: 50%; margin: 0 auto; }
        }
      `}</style>
    </section>
  );
};

export default PricingSection;